import React from 'react'
import styled from 'styled-components'
import Association from '../../images/association.png'
import White from '../white'
import Container from '../container'

const Wrapper = styled.div`
  padding-top: 120px;
  padding-bottom: 120px;
  background-color: #fff;
  @media(max-width: 768px) {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  h3 {
    text-align: center;
  }
`

const ProudAssociation = () => {
  return (
    <Wrapper>
      <White>
        <h3>in proud association with</h3>
        <Container>
          <img src={Association} alt="" />
        </Container>
      </White>
    </Wrapper>
  )
}

export default ProudAssociation
